import { filter } from 'es-toolkit/compat';

export const filterApplicationPendingProperties = (properties) =>
  properties
    ? filter(properties, (property) => {
        const { units } = property;
        const isApplicationPending = !units[0].basicInfo.isOnboardingComplete;
        return isApplicationPending;
      })
    : null;
